var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKostpriser = function SvgKostpriser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 42,
    x: 7,
    y: 3,
    className: "Kostpriser_svg__FlowIcon",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 20a1 1 0 0 1 0 2H14a1 1 0 0 1 0-2zm-11-6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2zm8-6a1 1 0 0 1 0 2H14a1 1 0 0 1 0-2z",
    className: "Kostpriser_svg__flowIconSnowStorm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 47c5.523 0 10-4.477 10-10a9.98 9.98 0 0 0-3.547-7.64A9.96 9.96 0 0 0 32 27c-5.523 0-10 4.477-10 10a9.99 9.99 0 0 0 4.332 8.24A9.95 9.95 0 0 0 32 47",
    className: "Kostpriser_svg__flowIconReversed"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Kostpriser_svg__FlowIcon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.56 34.16h2.53c.42 0 .804.245.98.628l.657 1.425h.677c.597 0 1.08.484 1.08 1.08v2.627a1.08 1.08 0 0 1-1.08 1.08H33.56zM27.08 32h5.4c.596 0 1.08.484 1.08 1.08V41h-6.48A1.08 1.08 0 0 1 26 39.92v-6.84c0-.596.484-1.08 1.08-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7 39.92a1.62 1.62 0 1 1 0 3.24 1.62 1.62 0 0 1 0-3.24m7.56 0a1.62 1.62 0 1 1 0 3.24 1.62 1.62 0 0 1 0-3.24"
  })))));
};
export default SvgKostpriser;